// extracted by mini-css-extract-plugin
export default {"submitButton":"modalEditTeamMember_submitButton__KTkDC","tableContainer":"modalEditTeamMember_tableContainer__I8VfL","textOpacity":"modalEditTeamMember_textOpacity__50-M3"};